function newGuid(): string {
    return typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
              const r = (Math.random() * 16) | 0
              const v = c === 'x' ? r : (r & 0x3) | 0x8
              return v.toString(16)
          })
}

export class QualityControlConcreteResultSpecimen {
    id = ''
    reportId = ''
    sortOrder = 0
    specimenId = ''
    dateTested = ''
    ageDays = ''
    avgDiameter = ''
    areaSqIn = ''
    maxLoadLbs = ''
    strengthPsi = ''
    percentOfSpec = ''
    fractureType = ''
    capType = ''
    testedBy = ''
}

export class QualityControlConcreteResult {
    id!: string
    job!: string
    reportSource = ''
    labName = ''
    reportNumber = ''
    inspector = ''
    sampleDate = ''
    reportDate = ''
    pourDate = ''
    pourLocation = ''
    mixNo = ''
    supplier!: number | undefined
    specifiedPsi = ''
    ticketNo = ''
    truckNo = ''
    plant = ''
    airTempF = ''
    concreteTempF = ''
    slump = ''
    airContentPct = ''
    unitWeightPcf = ''
    waterAdded = ''
    yieldCuYds = ''
    setNo = ''
    numberOfSpecimens = ''
    weather = ''
    remarks = ''
    startTime = ''
    stopTime = ''
    standardHours = ''
    overtimeHours = ''
    travelHours = ''
    createdOn!: Date
    modifiedOn!: Date
    specimens: QualityControlConcreteResultSpecimen[] = []

    static createNew(): QualityControlConcreteResult {
        const record = new QualityControlConcreteResult()
        record.id = newGuid()
        record.specimens = []
        return record
    }
}
